

import { mapGetters } from "vuex"

export default ({ key, fieldMap, defaultDataValues, success, prepare }) => {
  const fields = Object.keys(fieldMap)
  return {
    validations: {
      ...fields.reduce((allFields, field) => ({ ...allFields, [field]: {} }), {})
    },
    created() {
      this.extractValuesFromWebsite()
    },
    data() {
      return {
        ...fields.reduce((allFields, field) => ({ ...allFields, [field]: "" }), {}),
        ...(defaultDataValues || {}),

        loading: false,
      }
    },
    methods: {
      async save() {
        this.loading = true
        try {
          const details = this.getDetails()
          sessionStorage.setItem(key, JSON.stringify(details))
          await this.axios.put(`/api/websites/${this.website.uid}`, {
            properties: {
              ...this.website.properties,
              ...details,
            },
          })
          this.$store.dispatch('clearCacheSearch', "websites")
          if (success) {
            await this.$store.dispatch("toast/success", { message: success })
          }
        } catch (err) {
          await this.$store.dispatch("toast/handleError", err)
        }
        this.loading = false
      },
      extractValuesFromWebsite() {
        const storageProperties = JSON.parse(sessionStorage.getItem(key) || "{}")

        fields.forEach(field => {
          const key = fieldMap[field]
          let newVal

          newVal = this.website.properties[key]
          if (newVal == '0') newVal = false
          if (newVal == '1') newVal = true

          if (newVal === undefined) {
            newVal = newVal || storageProperties[key] || ""
          }
          if (!newVal && defaultDataValues[field] === undefined) {
            newVal = defaultDataValues[field]
          }

          this.$v[field].$model = newVal
        })
      },
      getDetails() {
        return fields.reduce((data, field) => ({
          ...data,
          [fieldMap[field]]: (prepare && prepare[field]) ? prepare[field](this[field]) : this[field]
        }), {})
      },
    },
    computed: {
      ...mapGetters({
        website: 'editor/website'
      }),
    },
  }
}
